module.exports = __webpack_public_path__ + "img/HowItWork_item_04.d9baf9a0.png";